import PanelRight from "src/Component/PanelRight";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import MainScreen from "src/Component/TV/MainScreen";
import FrameTV from "src/Component/FrameTV";
import BottomTV from "src/Component/BottomTV";

const PageId = 4;
const NextPageId = PageId + 1;
const BackPageId = PageId - 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);
  const [stepVisited, setStepVisited] = useState<number[]>([0]);

  const registerStepVisited = (newStep: number) => {
    setStep((prev) => {
      setStepVisited((prevVisited) => {
        const count = prevVisited.filter((step) => step === newStep).length;
        if (count < 3) return [...prevVisited, newStep];
        return prevVisited;
      });

      return newStep;
    });
  };

  useEffect(() => {
    if (PageId === currentPage) {
      if (!stepVisited.includes(step)) setStepVisited((prev) => [...prev, step]);
    } else {
      setStep(0);
      setStepVisited([0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, currentPage]);

  const title = "Continue Watching\nand Unified Watchlist";

  const description =
    "Seamlessly pick up where you left off across\nmultiple platforms, all combined into one intuitive\ndashboard. Whether it’s you favorite Disney+ series,\na Prime Video blockbuster, an HBO documentary, or\nan Apple TV+ original, “Continue Watching” ensures\neverything is just a tap away.\n\n<b>How it works:</b>\n•	A unified Watchlist from all your favorite content\nsources including content from your favorite OTT\napps allowing you to keep track of all your favorite\nmovies and series out there!\n\n•	Centralized Access: Brings all your platforms\ntogether in one place for easy navigation.\n\n•	Smart Syncing: Intelligent AI syncs your watchlists\nand progress across devices.";

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Continue",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title,
    description,
    rightSideComponent: (
      <PanelRight>
        <FrameTV scrollPosition={currentPage === PageId ? 200 : 0}>
          <MainScreen pageId={PageId} step={step} setStep={registerStepVisited} stepVisited={stepVisited} />
        </FrameTV>
        <BottomTV showSkips={false} backPageId={BackPageId} nextPageId={NextPageId} />
      </PanelRight>
    ),
    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
